// extracted by mini-css-extract-plugin
export default {"buttonContainer":"ButtonDownload_buttonContainer__e5LHb","buttonIcon":"ButtonDownload_buttonIcon__VVFev"};